import React from "react";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

export default function Pagination({ page, hasMore, onPrev, onNext, loading }) {
  return (
    <div className="stripe-pagination">
      <button
        className="stripe-page-btn"
        onClick={onPrev}
        disabled={page === 1 || loading}
      >
        <ArrowBackIosNewIcon style={{ fontSize: 11 }} />
        Prev
      </button>
      <span className="stripe-page-info">Page {page}</span>
      <button
        className="stripe-page-btn"
        onClick={onNext}
        disabled={!hasMore || loading}
      >
        Next
        <ArrowForwardIosIcon style={{ fontSize: 11 }} />
      </button>
    </div>
  );
}
